<template>
  <div class="layout-column">
    <Block
      :translation-context="blockTranslationContext(block.key)"
      :config="block.options"
      :key="`${keyBase}-block-${randomKey()}`"
      :type="block.type"
      v-for="(block, i) in localBlocks"
      v-if="block.type"
    ></Block>
  </div>
</template>
<script>
import Block from './Block.vue';
import Utilities from '../../lib/Utilities';
export default {
  props: {
    blocks: { type: Array, default: () => [] },
    index: { type: String },
  },
  components: {
    Block,
  },
  inject: ['translationContext'],
  computed: {
    keyBase() {
      return this.$vnode.key;
    },
  },
  data() {
    return {
      localBlocks: [],
      divider: null,
      showingMenu: false,
    };
  },
  created() {
    this.localBlocks = JSON.parse(JSON.stringify(this.blocks));
  },
  methods: {
    blockTranslationContext(i) {
      console.log(
        'PONG',
        this.config,
        `${this.translationContext}.columns.${this.index}.blocks.${i}`
      );

      return `${this.translationContext}.columns.${this.index}.blocks.${i}`;
    },
    randomKey() {
      return Utilities.key();
    },
    getBlocks() {
      return this.localBlocks;
    },
  },
};
</script>
<style lang="scss" scoped>
.layout-column {
  position: relative;
  .no-block {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    min-height: 50px;
    .add-content a.button {
      background-color: white;
      border: 1px solid #dedede;
      color: #ccc;
    }
  }
}
</style>
